import {
  createPopularUsCitiesLinks,
  createPopularUsStatesLinks,
} from '@tenants/definitions/exp/shared/internal-links';
import {
  HomeConfig,
} from '@tenants/types/tenant';
import {
  ROOT_PATH_SUFFIX,
} from 'data/addresses/go-search/types';

export function createHomeConfig(rootPathSuffix: string = ROOT_PATH_SUFFIX): HomeConfig {
  const homeConfig: HomeConfig = {
    heroImage: '/next/assets/images/in-service/military-hero.jpg',
    heroImageAlt: 'Military hero image',
    testimonialBlock: {
      backgroundImage: '/next/assets/images/agent-search/exp-mobile-banner-white-flag.jpg',
      heading: 'Hear From Our Military Agents',
      testimonials: [
        {
          image: '/next/assets/images/in-service/inservice-agent1.jpg',
          alt: 'Agent 1',
          name: 'Brittany Sims',
          company: 'eXp Realty, Virginia',
          text: '"I\'m absolutely loving eXp. From the systems to the support, being able to do real estate while knowing I can build my vision is such an awesome feeling. Everything just feels very aligned."',
          index: 0,
        },
        {
          image: '/next/assets/images/in-service/inservice-agent2.jpg',
          alt: 'Agent 2',
          name: 'Ruben Hernandez',
          company: 'eXp Realty, California',
          text: '"Creating a real estate company focused on assisting fellow veterans has helped me connect the dots and carry out the Marine Corps motto, \'Semper Fidelis,\' which stands for \'always faithful.\'"',
          index: 1,
        },
        {
          image: '/next/assets/images/in-service/inservice-agent3.jpg',
          alt: 'Agent 3',
          name: 'Kelli Salter',
          company: 'eXp Realty, North Carolina',
          text: '"eXp provides world-class resources that will help our agents grow beyond what we could offer as an independent."',
          index: 2,
        },
      ],
    },
    joinUsSection:{
      link: '/military-rewards-program',
      title: 'Why Join eXp Realty',
      title2: 'Military Rewards Program',
      description: 'When you join eXp Realty, you become part of a global family of agents and partners dedicated to transforming the real estate experience. Learn more about how we empower our agents with world-class education, strategic partnership and stock awards.',
      imageUrl: '/next/assets/images/join-us-military.jpg',
      buttonText: 'Learn More',
    },
    contentCards: {
      sectionTitleParts: ['Your Military', 'Moving', 'Experts'],
      cards: [
        {
          title: 'Relocation Assistance',
          image: '/next/assets/images/content-cards/relocation-assistance-inservice.jpg',
          titleColor: 'rgba(255, 255, 255, 0.8)',
          backgroundColor: '#163259',
          content: 'Moving to a new base or transitioning to civilian life? Explore your next destination with our interactive map. Our relocation experts are here to guide you every step of the way—from finding the perfect home to navigating VA loan options.',
          link: '/search?openSearch=true',
          desktopTransform: 'rotate(-5deg) translateY(-1.5em)',
          tabletTransform: 'none',
          rounded: true,
          altText: 'A man with his hair in a bun hugging a woman outside of a modern building.',
          buttonText: 'Start Your Journey Now',
        },
        {
          title: 'Military Rewards Program',
          image: '/next/assets/images/content-cards/military-rewards-program.png',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#6C82A0',
          content: 'Save money when buying or selling a home through our exclusive Military Rewards Program. Eligible service members, veterans, and military families receive cashback or concessions at closing.',
          link: '/military-rewards-program',
          tabletTransform: 'translateY(3em)',
          translateYTablet: '50',
          altText: 'A smiling family, with two kids playing inside a cardboard box',
          buttonText: 'Learn More about Benefits',
        },
        {
          title: 'Certified Specialists',
          image: '/next/assets/images/content-cards/certified-specialist.jpg',
          titleColor: '#0C0F24',
          backgroundColor: '#DAE0E7',
          content: 'Work with real estate professionals who understand military moves. Our certified agents, many of whom are veterans themselves, specialize in PCS transitions, VA loans, and military-specific housing needs.',
          link: '/agents-search',
          desktopTransform: 'rotate(2deg) translateY(-1.5em)',
          tabletTransform: 'none',
          translateYDesktop: '-20',
          altText: 'A group of professionals sitting around a table, engaged in conversation.',
          buttonText: 'Connect with a Specialist',
        },
        {
          title: 'In Service Life',
          image: '/next/assets/images/content-cards/in-service-life.jpg',
          titleColor: '#0C0F24',
          backgroundColor: '#EEEEEE',
          content: 'Get inspired by stories from fellow military members and veterans who have successfully navigated real estate and homeownership. Explore tips, testimonials, and community resources designed for military families.',
          link: '/inservice-life',
          desktopTransform: 'rotate(7deg) translateY(2em)',
          tabletTransform: 'translateY(3em)',
          translateYDesktop: '40',
          translateYTablet: '50',
          rounded: true,
          altText: 'Close-up of hands typing on a laptop.',
          buttonText: 'Read Military Stories',
        },
      ],
    },
    internalLinks: [
      createPopularUsCitiesLinks(rootPathSuffix),
      createPopularUsStatesLinks(rootPathSuffix),
    ],
  };

  return homeConfig;
}